// ============================================
// shippingQuote.js — Envío por peso para distribuidoras
// La distribuidora pide el cálculo desde /cart; el equipo pesa el pedido y
// captura el costo desde el link del correo (/cotizar-envio).
// ============================================
import { storeFetch } from './storeFetch';

// Nombre de la opción de envío en Medusa que cobra el monto cotizado.
export const QUOTE_OPTION_NAME = 'Envío por peso';

export const isQuoteOption = (opt) =>
  opt?.price_type === 'calculated' || opt?.name === QUOTE_OPTION_NAME;

// Estado: { status: 'none' | 'requested' | 'quoted' | 'stale', amount?, shipping_data? }
export async function getShippingQuote(cartId) {
  const data = await storeFetch(`/store/shipping-quote?cart_id=${encodeURIComponent(cartId)}`);
  return data.quote;
}

export async function requestShippingQuote(cartId, postalCode, note) {
  const data = await storeFetch('/store/shipping-quote', {
    method: 'POST',
    body: JSON.stringify({ cart_id: cartId, postal_code: postalCode, note }),
  });
  return data.quote;
}

// --- Equipo (link firmado del correo) -------------------------------------
export async function getQuoteRequest(c, t) {
  return storeFetch(`/store/shipping-quote-respond?c=${encodeURIComponent(c)}&t=${encodeURIComponent(t)}`);
}

export async function respondQuoteRequest(payload) {
  return storeFetch('/store/shipping-quote-respond', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
